export const extractDomain = email => {
  const domain = email.split('@')[1].match(/([^.@]+).[a-zA-Z.]+/g)[0];
  return domain;
};
